import React, { useEffect, useState } from "react";

function Menu() {
  return (
    <div className="menu_m">
      <canvas id="canvas" class="ani_hack" width="1280" height="768"></canvas>
    </div>
  );
}

export default Menu;
